import React from "react";
import "../styles/Facilities.css";

const Facilities = () => {
  return (
    <div className="admission-wrapper1">
      <div className="gurukul-container1">

      </div>
    </div>
  );
};

export default Facilities;
